import { TOSCountryType, TOSType } from "@faire/retailer-visitor-shared/views/terms-of-services/data/consts";
import { chooseArticleId } from "@faire/retailer-visitor-shared/views/terms-of-services/data/utils";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
export var getFairePayTOSArticleData = function() {
    return {
        linkOrId: chooseArticleId(TOSType.FAIRE_PAY, TOSCountryType.USA),
        locale: Language.ENG
    };
};
